import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useFilterOptionsSelect, useGrid } from '@Components/Grid';
import SelectCreatable from '@Components/Grid/components/Filters/SelectCreatable';
import filter, { components } from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('action', 'Action', ACTION_OPTIONS)
      .creatable(true)
      .multi(true),
    filter
      .options.store('publisher_id', 'Publisher', 'publishers')
      .multi(true),
    filter
      .options.list('subid', 'Subid', [])
      .component(SelectCreatableComponent)
      .multi(true),
    filter('ref_date', 'Date Range')
      .component(components.date),
  ], [])
}

const SelectCreatableComponent = ({ ...props }) => {
  const { store: { lists: { subids } } } = useGrid()
  const { id } = useParams()

  const options = useFilterOptionsSelect(subids, useMemo(() => ({
    params: { allocation_id: id },
    parserOptions: { labelKey: "subid", valueKey: 'subid', labelFormater: name => name },
  }), [id]))

  const optionsWithDefault = useMemo(() => [...options, { label: 'Default', value: '' }], [options])

  return <SelectCreatable {...props}
    options={optionsWithDefault}
  />
}

const ACTION_OPTIONS = [
  { label: 'Denied', value: 'denied' },
  { label: 'Allowed', value: 'allowed' },
  { label: 'Created', value: 'created' },
  { label: 'Reset', value: 'reset' },
  { label: 'Revenue', value: 'revenue' },
  { label: 'Revenue Correction', value: 'revenue_cor' },
  { label: 'Manual', value: 'manual' },
  { label: 'Revenue Suppressed', value: 'suppressed' },
]
